import PendingTable from './PendingTable'
export default PendingTable
